import {
    DEFAULT_TOTAL_RECORDS
} from "utils/constants";

const {
    EndPoints
} = require("settings/endpoints");
const {
    default: axiosInstance
} = require("./axios");
const zone_id = Number(localStorage.getItem("zone_id"));

export const fetchEmployees = (page_no, filter, limit = DEFAULT_TOTAL_RECORDS) => {
    return axiosInstance.get(EndPoints.EMPLOYEE.LIST, {
        params: {
            limit,
            page_no,
            zone_id,
            ...filter
            // total_count:totalItems
        }
    });
}

export const createEmployees = (payload) => {
    return axiosInstance.post(EndPoints.EMPLOYEE.CREATE, payload)
}

export const updateEmployees = (payload) => {
    return axiosInstance.put(EndPoints.EMPLOYEE.UPDATE, payload)
}


export const deleteEmployees = (payload) => {
    const url = EndPoints.EMPLOYEE.DELETE + `/${payload}`
    return axiosInstance.delete(url)
}

export const bulkUpdateAllocateZone = (payload) => {
    return axiosInstance.post(EndPoints.EMPLOYEE.CREATE, payload)
}

export const downloadCSV = () => {
    return axiosInstance.put(EndPoints.EMPLOYEE.DOWNLOAD_CSV, {
        responseType: 'blob'
    });
}


// API Calls for Employee Types

export const fetchEmployeeType = (page_no, filter, limit = DEFAULT_TOTAL_RECORDS) => {
    return axiosInstance.get(EndPoints.EMPLOYEETYPE.LIST, {
        params: {
            limit,
            page_no,
            zone_id,
            ...filter
            // total_count:totalItems
        }
    });
}

export const createEmployeeType = (payload) => {
    return axiosInstance.post(EndPoints.EMPLOYEETYPE.CREATE, payload)
}

export const updateEmployeeType = (payload) => {
    return axiosInstance.put(EndPoints.EMPLOYEETYPE.UPDATE, payload)
}


export const deleteEmployeeType = (payload) => {
    const url = EndPoints.EMPLOYEETYPE.DELETE + `/${payload}`
    return axiosInstance.delete(url)
}

export const downloadEmployeeTypeCSV = () => {
    return axiosInstance.put(EndPoints.EMPLOYEETYPE.DOWNLOAD_CSV, {
        responseType: 'blob'
    });
}


// API Calls for Employee Category

export const fetchEmployeeCategory = (page_no, filter, limit = DEFAULT_TOTAL_RECORDS) => {
    return axiosInstance.get(EndPoints.EMPLOYEECATEGORY.LIST, {
        params: {
            limit,
            page_no,
            zone_id,
            ...filter
            // total_count:totalItems
        }
    });
}

export const createEmployeeCategory = (payload) => {
    return axiosInstance.post(EndPoints.EMPLOYEECATEGORY.CREATE, payload)
}
export const createEmployeeCategories = (payload) => {
    return axiosInstance.post(EndPoints.EMPLOYEECATEGORY.CREATES, payload)
}

export const updateEmployeeCategory = (payload) => {
    return axiosInstance.put(EndPoints.EMPLOYEECATEGORY.UPDATE, payload)
}


export const deleteEmployeeCategory = (payload) => {
    const url = EndPoints.EMPLOYEECATEGORY.DELETE + `/${payload}`
    return axiosInstance.delete(url)
}

export const downloadEmployeeCategoryCSV = () => {
    return axiosInstance.put(EndPoints.EMPLOYEECATEGORY.DOWNLOAD_CSV, {
        responseType: 'blob'
    });
}